import React from 'react';
import {useTranslation} from 'react-i18next';
import {normalizeLanguage} from './languages';
import {sdkTranslation,sdkDisplayElement} from './sdk-text';

// Only translate known catalogue labels. IDs, quantities and custom names stay data.
export function cardNameElement(text){
 return sdkDisplayElement(text,['卡 #{{v0}} · 角色待提供','{{v0}} 卡包','{{v0}}卡包']);
}
const rewardNames=/((?:超級\s*VIP|VIP)\s*[月周週]卡|普通\s*[月周週]卡|大富翁經驗值|每日抽獎券|每月抽獎券|免費\s*OP\s*幣|OP\s*幣|擲骰次數|擲骰|次)/g;
export default function CardRewardText({text}){
 const {i18n}=useTranslation('translations');
 if(typeof text!=='string'||normalizeLanguage(i18n.language)==='zh-Hant')return <>{text}</>;
 return <>{text.split(rewardNames).map((part,index)=>{
  const normalized=part.replace(/周卡/g,'週卡').replace(/普通\s+([月週]卡)/g,'普通$1');
  const key=/^超級\s*VIP\s*月卡$/.test(part)?'超級 VIP 月卡':/^VIP\s*月卡$/.test(part)?'VIP 月卡':/^(?:免費\s*)?OP\s*幣$/.test(part)?'OP 幣':part;
  const label=/^超級\s*VIP\s*週卡$/.test(normalized)?'超級 VIP 週卡':/^VIP\s*週卡$/.test(normalized)?'VIP 週卡':key===part?normalized:key;
  return <React.Fragment key={index}>{sdkTranslation(label,i18n.language)}</React.Fragment>;
 })}</>;
}
